import { Order } from 'effect';

const isNumberShaped = (token: string): boolean => Number.isFinite(Number(token));

/**
 * Orders the values of one filter in a total order, so one value set writes one URL.
 *
 * Number-shaped tokens come first, by numeric value. All other tokens follow.
 * The text decides last, so two distinct tokens never compare equal: `.0` comes
 * before `0`, and `0` comes before `00`.
 */
export const compareTokens: Order.Order<string> = Order.combineAll([
  Order.mapInput(Order.Boolean, (token: string) => !isNumberShaped(token)),
  Order.mapInput(Order.Number, (token: string) => (isNumberShaped(token) ? Number(token) : 0)),
  Order.String,
]);
